import { useEffect, useRef, useState } from 'react'

import { clsx } from 'clsx'

import { Post } from '@tribeplatform/gql-client/types'

import { ReplyBar } from '../Post/ReplyBar.js'

interface Props {
  post: Post
  className?: string
}
export const ReplyListStickyFooter = ({ post, className }: Props) => {
  const stickyElObserverRef = useRef(null)
  const [isFooterStuck, setIsFooterStuck] = useState(false)
  const observerRef = useRef(null)

  // Store sticky mode to handle different style
  useEffect(() => {
    if (stickyElObserverRef.current) {
      observerRef.current = new IntersectionObserver(
        ([e]) => {
          setIsFooterStuck(!e.isIntersecting)
        },
        { root: null, threshold: 1 },
      )
      observerRef.current.observe(stickyElObserverRef.current)
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect()
      }
    }
  }, [])

  return (
    <>
      <div ref={stickyElObserverRef} className="!m-0" />
      <div
        className={clsx(
          'sticky bottom-0 px-5 bg-surface shadow-card z-20',
          { 'sm:rounded-card': !isFooterStuck },
          className,
        )}
      >
        <div className="pt-2 pb-3">
          <ReplyBar post={post} />
        </div>
      </div>
    </>
  )
}
